/* GemKrishna Custom Rudraksha Kantha builder (October 2026 redesign).
   Markup: snippets/gk-kantha.liquid. Data: snippets/gk-kantha-data.liquid (prices always from Shopify).
   Rules:
   - Siddh Mala: 1-14 Mukhi + Ganesh + Gauri Shankar = 16 main beads. Indra Mala: 1-21 Mukhi + Ganesh + Gauri Shankar = 23.
   - The origin choice limits which beads can fill each place; the customer picks ONE bead per place.
   - Sizes come from Shopify size variants and are sorted by size. Sizes "as per availability" are shown in order
     but cannot be bought online. Nepal 16-21 Mukhi are always "Ask for price".
   - If any part needs a quotation, the whole Kantha goes to the quotation flow; nothing unknown is sold at Rs 0.
   - Back chain (internally "base beads"): the previous builder's rule (count = (length - main beads) / bead size,
     rounded; Kantha making price from Shopify by back chain bead type; Nepal back chain beads add their per-bead
     price). "Plain thread" uses the Shopify variant "Kantha mala / No base beads" and adds no back chain products.
   - GJSPC report: included free (value shown); never added as a paid item. No free gift is added. */
(function () {
  'use strict';
  var root = document.getElementById('gk-kantha');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  var DATA;
  try { DATA = JSON.parse(document.getElementById('gk-kantha-data').textContent); } catch (e) { DATA = null; }
  if (!DATA) { root.insertAdjacentHTML('afterbegin', '<p class="gkk-alert">The Kantha builder could not load. Please refresh, or message us on <a href="https://wa.me/917678275972">WhatsApp</a>.</p>'); return; }

  var ROUTE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var WHATSAPP_NUMBER = '917678275972';
  var PRIVATE_REF_KEY = '_GK Build Ref';
  var MAX_DESIGN = 10 * 1024 * 1024;

  var MALAS = {
    siddh: { key: 'siddh', name: 'Siddh Mala', alt: 'Siddha Mala', top: 14, reportValue: 150000, reportName: 'Siddh Mala report' },
    indra: { key: 'indra', name: 'Indra Mala', alt: '', top: 21, reportValue: 300000, reportName: 'Indra Mala report' }
  };
  var BASIC_REPORT_VALUE = 35000;
  var ORIGINS = [
    { key: 'idn', name: 'Indonesian', set: ['indonesia'], desc: 'Every bead from Indonesia (Java).' },
    { key: 'np', name: 'Nepal', set: ['nepal'], desc: 'Every bead from Nepal.' },
    { key: 'idn-np', name: 'Indonesian + Nepal', set: ['indonesia', 'nepal'], desc: 'Choose Indonesian or Nepal for each bead.' },
    { key: 'np-ind', name: 'Nepal + India', set: ['nepal', 'india'], desc: 'Choose Nepal or Indian for each bead where we have both.' },
    { key: 'mix', name: 'Mix', set: ['indonesia', 'nepal', 'india'], desc: 'Every origin we stock. Choose for each bead.' }
  ];
  var ORIGIN_LABEL = { indonesia: 'Indonesian', nepal: 'Nepal', india: 'Indian' };
  var BUILDS = [
    { key: 'dhaga', name: 'Dhaga + 1 Mukhi basket', desc: 'Strung on strong thread, with the 1 Mukhi in a basket fitting.', img: 'thread', basket: true, thread: true },
    { key: 'cap-thread', name: 'Silver capping in thread', desc: '925 sterling silver caps on the beads, strung on thread.', img: 'capping', thread: true },
    { key: 'cap-wire', name: 'Silver capping in wire', desc: '925 sterling silver caps joined with silver wire. Quoted at the day\'s silver rate.', img: 'wire' },
    { key: 'all-silver', name: 'All-silver construction', desc: 'Silver connections throughout, in the design you choose. Quoted by our team.', img: 'allSilver' }
  ];
  var SILVER_DESIGNS = [
    { key: 'plain', name: 'Plain silver connections' },
    { key: 'balls', name: 'Silver balls between alternate beads' },
    { key: 'cubes', name: 'Silver cubes between alternate beads' }
  ];
  var COLOURS = ['Red', 'Maroon', 'Saffron', 'Yellow', 'Gold', 'Pink', 'Purple', 'Blue', 'Green', 'Brown', 'Black', 'White'];
  var COLOUR_HEX = { Red: '#b3261e', Maroon: '#6d1a1f', Saffron: '#e8771e', Yellow: '#e2b416', Gold: '#c9a13b', Pink: '#e07aa0', Purple: '#6b3d8f', Blue: '#2551a8', Green: '#2e7d4f', Brown: '#6b4426', Black: '#1b1b1b', White: '#f4f1ea' };
  var GROUP_OPT = { none: 'No base beads', sacred: 'Sacred beads (Tulsi, Chandan and more)', '5': '5 Mukhi', '346': '3, 4 or 6 Mukhi', '7': '7 Mukhi', combo: 'Any 2 combined' };
  var STEPS = ['mala', 'origin', 'beads', 'base', 'build', 'extras', 'review'];

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function money(c) { var v = Math.round(Number(c) || 0); return '₹' + (v / 100).toLocaleString('en-IN', { minimumFractionDigits: v % 100 ? 2 : 0, maximumFractionDigits: 2 }); }
  function sized(u, w) { if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; if (!/cdn\.shopify\.com/.test(u)) return u; return /[?&]width=/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function normSize(s) { return String(s || '').replace(/[‒-―]/g, '-').replace(/\s+/g, ' ').trim(); }
  function sizeLower(s) { var m = normSize(s).match(/(\d+(?:\.\d+)?)/); return m ? Number(m[1]) : 9999; }
  function sizeMid(s) { var n = (normSize(s).match(/\d+(?:\.\d+)?/g) || []).map(Number); if (!n.length) return 0; return n.length > 1 ? (n[0] + n[1]) / 2 : n[0]; }
  function isSizeLabel(s) { return /^\d+(\.\d+)?\s*(-\s*\d+(\.\d+)?)?\s*\+?\s*mm$/i.test(normSize(s)); }
  function plural(n, a, b) { return n + ' ' + (n === 1 ? a : b); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) { return r.text().then(function (t) { var b = null; try { b = t ? JSON.parse(t) : null; } catch (e) { b = null; } if (!r.ok) { var e2 = new Error((b && (b.description || b.message)) || 'The request failed (' + r.status + ').'); e2.status = r.status; throw e2; } return b; }); });
  }
  function postJSON(path, body) { return fetchJSON(ROUTE_ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); }

  /* ---------- catalogue ---------- */
  var ROWS = {};
  String(DATA.rows || '').split(/\r?\n/).forEach(function (line) {
    var f = line.trim().split('|');
    if (f.length < 8 || !f[0].trim()) return;
    ROWS[f[0].trim()] = { key: f[0].trim(), name: f[1].trim(), originText: f[2].trim(), deity: f[3].trim(), origin: f[4].trim(), approxMm: Number(f[5]) || 0, note: f[6].trim(), img: f[7].trim() };
  });
  var PRODUCTS = {};
  (DATA.products || []).forEach(function (p) { if (!PRODUCTS[p.key]) PRODUCTS[p.key] = p; });
  var ENQUIRY = {}; (DATA.enquiryOnly || []).forEach(function (k) { ENQUIRY[k] = true; });
  var QUOTE_SIZES = DATA.quoteSizes || {};

  function roleOfKey(k) {
    var m = String(k).match(/^(np|idn|ind|ram|him)-(\d+)$/);
    if (m) return String(Number(m[2]));
    if (/^sp-ga-/.test(k)) return 'ganesh';
    if (/^sp-gs-/.test(k)) return 'gs';
    return null;
  }
  var BEADS = {};
  Object.keys(ROWS).concat(Object.keys(PRODUCTS)).forEach(function (k) {
    if (BEADS[k]) return;
    var role = roleOfKey(k);
    if (!role) return;
    var r = ROWS[k] || {}, p = PRODUCTS[k] || null;
    var origin = r.origin || (p && p.collection) || '';
    if (!ORIGIN_LABEL[origin]) return;
    var name = r.name || (p && p.title.replace(/\s*\(Bracelet Bead\)\s*$/, '').replace(/\s*[–-]\s*(Nepal|Indonesia.*)$/, '')) || k;
    BEADS[k] = {
      key: k, role: role, origin: origin, originLabel: ORIGIN_LABEL[origin], name: name,
      sourceNote: r.originText && r.originText !== 'Nepal' && r.originText !== 'Indonesia (Java)' && r.originText !== 'India' ? r.originText : '',
      deity: r.deity || '', img: (p && p.img) || r.img || '', url: p ? p.url : '', product: p,
      approxMm: r.approxMm || 0,
      /* no product, or no real "Bead size" variants: sold by enquiry only (never a guessed size) */
      enquiry: !!ENQUIRY[k] || !p || !p.hasSizes
    };
  });

  /* Size options for one bead, numerically sorted; "as per availability" sizes sit in their numeric place.
     Variants that are not a size (e.g. "Unverified size (not for sale)") are never offered. */
  function sizeOptions(b) {
    if (b.enquiry) return [];
    var opts = [];
    b.product.variants.forEach(function (v) {
      if (!isSizeLabel(v.size)) return;
      var price = Number(v.price) || 0;
      opts.push({ size: normSize(v.size), price: price, variantId: v.id, purchasable: !!v.available && price > 0, unavailable: !v.available });
    });
    (QUOTE_SIZES[b.key] || []).forEach(function (s) {
      s = normSize(s);
      if (!opts.some(function (o) { return o.size === s; })) opts.push({ size: s, quote: true });
    });
    opts.sort(function (a, c) { return sizeLower(a.size) - sizeLower(c.size) || sizeMid(a.size) - sizeMid(c.size); });
    return opts;
  }
  function sizeText(s) { return normSize(s).replace(/(\d)-(\d)/, '$1–$2'); }

  /* ---------- state ---------- */
  var S = {
    mala: null, origin: null, sel: {}, length: null, baseSize: 8, bases: ['5'], chain: 'beads', build: null, colour: 'Red',
    silverDesign: null, energy: 'basic', note: '', design: null, open: 'mala', done: {}
  };
  var busy = false;
  var buildRef = 'GKK-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 8).toUpperCase();

  function mala() { return MALAS[S.mala] || null; }
  function origin() { return ORIGINS.filter(function (o) { return o.key === S.origin; })[0] || null; }
  function roles() {
    var m = mala(); if (!m) return [];
    var out = [];
    for (var i = 1; i <= m.top; i++) out.push(String(i));
    out.push('ganesh', 'gs');
    return out;
  }
  function roleName(r) { return r === 'ganesh' ? 'Ganesh' : r === 'gs' ? 'Gauri Shankar' : r + ' Mukhi'; }
  function eligible(role) {
    var o = origin(); if (!o) return [];
    return Object.keys(BEADS).map(function (k) { return BEADS[k]; }).filter(function (b) { return b.role === role && o.set.indexOf(b.origin) > -1; })
      .sort(function (a, b) { return o.set.indexOf(a.origin) - o.set.indexOf(b.origin) || (a.sourceNote ? 1 : 0) - (b.sourceNote ? 1 : 0) || a.key.localeCompare(b.key); });
  }
  /* What a role's selection resolves to. */
  function resolve(role) {
    var s = S.sel[role];
    if (!s || !BEADS[s.key]) return { state: 'empty' };
    var b = BEADS[s.key];
    if (b.enquiry) {
      var reason = ENQUIRY[b.key] ? 'Ask for price' : 'Ask for price and availability';
      /* an enquiry bead counts only once the customer includes it and gives the size they want */
      if (!s.include) return { state: 'include', bead: b, reason: reason, pref: s.pref || '' };
      if (!String(s.pref || '').trim()) return { state: 'size', bead: b, reason: reason, pref: '' };
      return { state: 'quote', bead: b, reason: reason, pref: s.pref.trim() };
    }
    var o = s.size ? sizeOptions(b).filter(function (x) { return x.size === s.size; })[0] : null;
    if (!o) return { state: 'size', bead: b };
    if (o.quote) return { state: 'quote', bead: b, opt: o, reason: 'Ask for availability' };
    if (!o.purchasable) return { state: 'quote', bead: b, opt: o, reason: o.unavailable ? 'Currently unavailable' : 'Price pending' };
    return { state: 'priced', bead: b, opt: o, price: o.price };
  }
  function isDone(st) { return st === 'priced' || st === 'quote'; }
  function doneCount() { return roles().filter(function (r) { return isDone(resolve(r).state); }).length; }

  /* ---------- base beads (rules of the previous builder) ---------- */
  var BASES = {};
  (DATA.baseCards || []).forEach(function (c) { BASES[c.key] = c; });
  function npVariant(m, size) {
    var vs = (DATA.npBase && DATA.npBase.variants) || [];
    return vs.filter(function (v) { return v.o[0] === m + ' Mukhi' && v.o[1] === size + ' mm' && v.available && Number(v.price) > 0; })[0] || null;
  }
  if (DATA.npBase && DATA.npBase.variants && DATA.npBase.variants.length) {
    BASES.np5 = { key: 'np5', name: '5 Mukhi Rudraksha (Nepal)', line: 'Priced per bead by size', img: DATA.npBase.img, group: '5', nepal: '5' };
    BASES.np6 = { key: 'np6', name: '6 Mukhi Rudraksha (Nepal)', line: 'Priced per bead by size', img: DATA.npBase.img6, group: '346', nepal: '6' };
  }
  var BASE_ORDER = ['5', 'np5', '3', '4', '6', 'np6', '7', 'tulsi', 'karungali', 'rakt-chandan', 'shwet-chandan', 'haldi', 'kamal-gatta', 'vaijanti'].filter(function (k) { return BASES[k]; });
  /* the back chain beads that apply: none with a plain thread back chain (the chosen kinds are kept for switching back) */
  function activeBases() { return S.chain === 'thread' ? [] : S.bases; }
  function groupKey(list) {
    var r = list.map(function (k) { return BASES[k]; }).filter(function (b) { return b && /^\d+$/.test(String(b.nepal || b.key)); }).map(function (b) { return Number(b.nepal || b.key); });
    if (!r.length) return list.length ? 'sacred' : 'none';
    if (list.length > 1) return 'combo';
    if (r[0] === 5) return '5';
    if (r[0] === 7) return '7';
    return '346';
  }
  function bodyVariant() {
    var b = DATA.body || {}, opts = b.options || [], ti = opts.indexOf('Mala type'), bi = opts.indexOf('Base beads');
    if (ti < 0 || bi < 0) return null;
    var want = GROUP_OPT[groupKey(activeBases())];
    return (b.variants || []).filter(function (v) { return v.o[ti] === 'Kantha mala' && v.o[bi] === want && v.available && Number(v.price) > 0; })[0] || null;
  }
  function mainLengthMm() {
    return roles().reduce(function (sum, r) {
      var res = resolve(r);
      if (res.opt && res.opt.size) return sum + sizeMid(res.opt.size);
      if (res.bead) return sum + (res.bead.approxMm || 16);
      return sum + 16;
    }, 0);
  }
  function baseCalc() {
    var lengthMm = (S.length || 0) * 25.4;
    var mainMm = mainLengthMm();
    var out = { lengthMm: lengthMm, mainMm: mainMm, fill: 0, short: false, over: false, approx: roles().some(function (r) { var x = resolve(r); return !(x.opt && x.opt.size); }) };
    if (!S.length) return out;
    var rem = lengthMm - mainMm;
    if (rem < 0) out.over = true;
    if (activeBases().length) out.fill = Math.max(0, Math.round(rem / S.baseSize));
    else if (rem > 16 && S.chain !== 'thread') out.short = true;
    return out;
  }
  function baseLines(calc) {
    /* Nepal base beads add a per-bead price; beads alternate when two kinds are chosen. */
    var lines = [], missing = [];
    var list = activeBases();
    if (!calc.fill || !list.length) return { lines: lines, missing: missing };
    var counts = {};
    for (var i = 0; i < calc.fill; i++) { var k = list[i % list.length]; counts[k] = (counts[k] || 0) + 1; }
    Object.keys(counts).forEach(function (k) {
      var b = BASES[k];
      if (!b || !b.nepal) return;
      var v = npVariant(b.nepal, S.baseSize);
      if (!v) { missing.push(b.name + ', ' + S.baseSize + ' mm'); return; }
      lines.push({ key: k, name: b.name, n: counts[k], variantId: v.id, each: Number(v.price), total: Number(v.price) * counts[k] });
    });
    return { lines: lines, missing: missing };
  }

  /* ---------- totals and status ---------- */
  function build() { return BUILDS.filter(function (b) { return b.key === S.build; })[0] || null; }
  function evaluate() {
    var known = [], quote = [], todo = [];
    var main = 0;
    roles().forEach(function (r) {
      var res = resolve(r);
      if (res.state === 'empty') todo.push({ step: 'beads', role: r, msg: 'Choose a bead for ' + roleName(r) + '.' });
      else if (res.state === 'include') todo.push({ step: 'beads', role: r, msg: 'Include ' + roleName(r) + ' in your quotation request.' });
      else if (res.state === 'size') todo.push({ step: 'beads', role: r, msg: (res.bead.enquiry ? 'Enter the bead size you want for ' : 'Select a bead size for ') + roleName(r) + '.' });
      else if (res.state === 'quote') quote.push(roleName(r) + ' (' + res.bead.originLabel + (res.opt && res.opt.size ? ', ' + sizeText(res.opt.size) : res.pref ? ', requested size ' + res.pref : '') + '): ' + res.reason);
      else main += res.price;
    });
    if (main) known.push({ label: 'Main Rudraksha beads', amount: main });
    if (!mala()) todo.unshift({ step: 'mala', msg: 'Choose Siddh Mala or Indra Mala.' });
    if (mala() && !origin()) todo.push({ step: 'origin', msg: 'Choose the origin.' });
    var calc = baseCalc();
    /* length is optional; with a length the main and base beads must fit it */
    if (S.chain !== 'thread' && !S.bases.length) todo.push({ step: 'base', msg: 'Choose at least one kind of back chain bead, or choose Plain thread.' });
    if (!S.length) { if (activeBases().some(function (k) { return BASES[k] && BASES[k].nepal; })) quote.push('Nepal back chain beads: the number depends on the length, which our team confirms with you'); }
    else if (calc.over) todo.push({ step: 'base', msg: 'Your main beads are longer than this length. Choose a longer Kantha.' });
    else if (calc.short) todo.push({ step: 'base', msg: 'Add back chain beads to reach your length, or choose Plain thread.' });
    var body = bodyVariant();
    var chainName = S.chain === 'thread' ? 'plain thread back chain' : 'back chain beads (' + GROUP_OPT[groupKey(activeBases())] + ')';
    if (body) known.push({ label: 'Kantha making, ' + chainName, amount: Number(body.price) });
    else quote.push('Kantha making with ' + chainName + ': price not set up online');
    var bl = baseLines(calc);
    bl.lines.forEach(function (l) { known.push({ label: l.name + ' × ' + l.n, amount: l.total }); });
    bl.missing.forEach(function (m) { quote.push(m + ': price not set up online'); });
    var b = build();
    if (!b) todo.push({ step: 'build', msg: 'Choose how your Kantha is made.' });
    else if (b.key === 'dhaga') quote.push('1 Mukhi basket: price pending');
    else if (b.key === 'cap-thread') {
      var full = DATA.fullCapping, cap = DATA.capBig, n = roles().length;
      if (full && full.available && cap && cap.available) { known.push({ label: '925 silver capping', amount: Number(full.price) }); known.push({ label: '925 silver caps on main beads × ' + n, amount: Number(cap.price) * n }); }
      else quote.push('Silver capping: price not set up online');
    } else if (b.key === 'cap-wire') quote.push('Silver capping in wire: priced at the day\'s silver rate');
    else if (b.key === 'all-silver') { if (!S.silverDesign) todo.push({ step: 'build', msg: 'Choose a silver design.' }); quote.push('All-silver construction (' + ((SILVER_DESIGNS.filter(function (d) { return d.key === S.silverDesign; })[0] || {}).name || 'design to choose') + '): price pending'); }
    if (b && (b.key === 'cap-wire' || b.key === 'all-silver') && S.chain === 'thread') quote.push('Plain thread back chain with ' + b.name.toLowerCase() + ': our team confirms how the back chain is finished');
    var en = energyOpt();
    if (en.price) known.push({ label: en.title, amount: Number(en.price) });
    var subtotal = known.reduce(function (s, x) { return s + x.amount; }, 0);
    return { known: known, quote: quote, todo: todo, subtotal: subtotal, calc: calc, body: body, baseLines: bl, purchasable: !todo.length && !quote.length };
  }
  /* Same four choices as the shared energisation box (snippets/pooja-pran-pratishtha-box.liquid). Exactly one applies. */
  var ENERGY_FREE = {
    basic: { key: 'basic', title: 'Basic Energisation', label: 'Basic Energisation (included)', desc: 'Basic energisation of your Kantha before dispatch.', price: 0 },
    none: { key: 'none', title: 'No energisation', label: 'No energisation', desc: 'Send my order without energisation or pooja.', price: 0 }
  };
  function energyChoices() {
    var names = { pooja: 'Pooja / Pran Pratishtha', vedic: 'Vedic Pooja / Pran Pratishtha with Video' };
    var paid = (DATA.energisation || []).map(function (e) { var n = names[e.key] || e.title; return { key: e.key, title: n, label: n, price: Number(e.price) || 0, id: e.id, handle: e.handle, available: e.available }; });
    return [ENERGY_FREE.basic].concat(paid, [ENERGY_FREE.none]);
  }
  function energyOpt() { return energyChoices().filter(function (e) { return e.key === S.energy; })[0] || ENERGY_FREE.basic; }

  /* ---------- step 1: Mala ---------- */
  function renderMalas() {
    var imgs = DATA.images || {};
    $('[data-malas]').innerHTML = ['siddh', 'indra'].map(function (k) {
      var m = MALAS[k], count = m.top + 2;
      var img = imgs[k] ? '<img class="gkk-card__img" src="' + esc(sized(imgs[k], 600)) + '" alt="' + esc(k === 'siddh' ? 'Example Siddh Mala: 1 to 14 Mukhi Indonesian Rudraksha Kantha with Gauri Shankar' : m.name + ' example') + '" width="300" height="300" loading="lazy">' : placeholder(m.name);
      return '<label class="gkk-card"><input type="radio" name="gkk-mala" value="' + k + '"' + (S.mala === k ? ' checked' : '') + '><span class="gkk-card__box">' + img +
        '<span class="gkk-card__name">' + esc(m.name) + (m.alt ? ' <span class="gkk-card__alt">(' + esc(m.alt) + ')</span>' : '') + '</span>' +
        '<span class="gkk-card__desc">1 to ' + m.top + ' Mukhi, Ganesh and Gauri Shankar. ' + count + ' main beads.</span>' +
        (k === 'siddh' && imgs.siddh ? '<span class="gkk-card__fine">Photo: an example 1-14 Mukhi Indonesian Kantha.</span>' : '') + '</span></label>';
    }).join('');
  }
  function renderMalaDetail() {
    var m = mala(), box = $('[data-mala-detail]');
    if (!m) { box.hidden = true; return; }
    box.hidden = false;
    var list = roles().map(roleName).join(', ');
    box.innerHTML = '<p><strong>' + esc(m.name) + ':</strong> ' + esc(list) + '. ' + roles().length + ' main beads. The back chain is chosen in step 4 and counted separately.</p>' +
      reportHtml(true) +
      '<button type="button" class="gkk-link" data-info-open="' + m.key + '">More about the ' + esc(m.name) + '</button>';
  }
  function reportHtml(compact) {
    var m = mala(); if (!m) return '';
    var logo = (DATA.images || {}).gjspc;
    return '<div class="gkk-reportbox">' + (logo ? '<img src="' + esc(sized(logo, 160)) + '" alt="GJSPC Laboratory logo" width="64" height="64" loading="lazy">' : '') +
      '<div><p class="gkk-reportbox__title">GJSPC Laboratory report included free</p><p class="gkk-reportbox__value">Report value ' + money(m.reportValue) + ' · You pay ₹0</p>' +
      (compact ? '' : '<p class="gkk-help">Your Kantha includes a GJSPC Laboratory report documenting the identifying characteristics of the Rudraksha examined.</p>') +
      '<button type="button" class="gkk-link" data-info-open="report">About the report</button></div></div>';
  }

  /* ---------- step 2: origin ---------- */
  function renderOrigins() {
    $('[data-origins]').innerHTML = ORIGINS.map(function (o) {
      return '<label class="gkk-card gkk-card--text"><input type="radio" name="gkk-origin" value="' + o.key + '"' + (S.origin === o.key ? ' checked' : '') + '><span class="gkk-card__box"><span class="gkk-card__name">' + esc(o.name) + '</span><span class="gkk-card__desc">' + esc(o.desc) + '</span></span></label>';
    }).join('');
  }
  /* Keep valid selections, drop and explain the ones that no longer fit. Where only one bead fits a place it is
     shown as that bead, but its size (or, for enquiry beads, inclusion and size) still has to be chosen. */
  function reconcile(reason) {
    var dropped = [];
    var valid = {};
    roles().forEach(function (r) { valid[r] = true; });
    Object.keys(S.sel).forEach(function (r) {
      var s = S.sel[r], b = BEADS[s.key], o = origin();
      if (!valid[r]) { delete S.sel[r]; dropped.push(roleName(r) + ' (not part of the ' + mala().name + ')'); return; }
      if (!b || !o || o.set.indexOf(b.origin) < 0) { delete S.sel[r]; dropped.push(roleName(r) + ' (' + (b ? b.originLabel : 'bead') + ' is not in ' + (o ? o.name : 'this origin') + ')'); }
    });
    roles().forEach(function (r) {
      if (S.sel[r]) return;
      var list = eligible(r);
      if (list.length === 1) S.sel[r] = { key: list[0].key, size: null, pref: '', include: false };
    });
    var n = $('[data-origin-notice]');
    if (dropped.length && reason) { n.hidden = false; n.textContent = 'These no longer fit your ' + reason + ' and need a new choice: ' + dropped.join('; ') + '.'; }
    else if (reason) { n.hidden = true; n.textContent = ''; }
    return dropped;
  }

  /* ---------- step 3: main beads ---------- */
  function placeholder(label) { return '<span class="gkk-ph" role="img" aria-label="' + esc(label) + ': image coming soon"><span>Image coming soon</span></span>'; }
  function renderRoles() {
    var host = $('[data-roles]');
    var rs = roles();
    host.innerHTML = rs.map(function (r) { return '<li class="gkk-role" data-role="' + r + '"></li>'; }).join('');
    rs.forEach(renderRole);
    renderProgress();
  }
  function roleHead(r) {
    var s = S.sel[r], res = resolve(r);
    var cur = s && BEADS[s.key];
    var need = { empty: 'Choose a bead', size: cur && cur.enquiry ? 'Enter a size' : 'Select a size', include: 'Include for quotation' }[res.state];
    var status = res.state === 'priced' ? '<span class="gkk-price">' + money(res.price) + '</span>' : res.state === 'quote' ? '<span class="gkk-quote">' + esc(res.reason) + '</span>' : '<span class="gkk-need">' + esc(need || 'Choose a bead') + '</span>';
    var meta = cur ? cur.originLabel + (cur.sourceNote ? ' (' + cur.sourceNote + ')' : '') + (res.opt && res.opt.size ? ', ' + sizeText(res.opt.size) : res.state === 'quote' && res.pref ? ', requested ' + res.pref : '') : 'Not chosen';
    return '<div class="gkk-role__head">' +
      (cur && cur.img ? '<img class="gkk-role__img" src="' + esc(sized(cur.img, 160)) + '" alt="' + esc(cur.name + ', ' + cur.originLabel) + '" width="56" height="56" loading="lazy">' : '<span class="gkk-role__img gkk-role__img--empty" aria-hidden="true"></span>') +
      '<div class="gkk-role__text"><p class="gkk-role__name">' + esc(roleName(r)) + (isDone(res.state) ? ' <span class="gkk-tick" aria-label="complete">✓</span>' : '') + '</p>' +
      '<p class="gkk-role__meta">' + esc(meta) + '</p></div>' +
      '<div class="gkk-role__status">' + status + '</div></div>';
  }
  function refreshRoleHead(r) {
    var li = $('[data-role="' + r + '"]'), head = li && $('.gkk-role__head', li);
    if (head) head.outerHTML = roleHead(r);
    if (li) { li.setAttribute('data-state', resolve(r).state); if (isDone(resolve(r).state)) li.classList.remove('is-attention'); }
  }
  function renderRole(r) {
    var li = $('[data-role="' + r + '"]');
    if (!li) return;
    var list = eligible(r), s = S.sel[r], res = resolve(r);
    var cur = s && BEADS[s.key];
    var html = roleHead(r);
    if (!list.length) {
      html += '<p class="gkk-help">No ' + esc(roleName(r)) + ' bead in this origin. Choose another origin or ask us on WhatsApp.</p>';
    } else {
      if (list.length > 1) {
        html += '<fieldset class="gkk-role__origins"><legend class="gkk-sr">' + esc(roleName(r)) + ' origin</legend>' + list.map(function (b) {
          return '<label class="gkk-pill"><input type="radio" name="gkk-bead-' + r + '" value="' + esc(b.key) + '"' + (cur && cur.key === b.key ? ' checked' : '') + '><span><img src="' + esc(sized(b.img, 80)) + '" alt="" width="24" height="24" loading="lazy">' + esc(b.originLabel + (b.sourceNote ? ' (' + b.sourceNote + ')' : '')) + '</span></label>';
        }).join('') + '</fieldset>';
      }
      if (cur) {
        if (cur.enquiry) {
          html += '<p class="gkk-help">' + (ENQUIRY[cur.key] ? 'Nepal 16 to 21 Mukhi are "Ask for price" only. We quote them personally and they are never charged online.' : 'This bead is not priced online. We confirm availability and price personally.') + '</p>' +
            '<label class="gkk-check"><input type="checkbox" data-include="' + r + '"' + (s.include ? ' checked' : '') + '><span>Include ' + esc(roleName(r)) + ' (' + esc(cur.originLabel) + ') in my quotation request</span></label>';
          if (s.include) html += '<div class="gkk-field gkk-field--tight"><label class="gkk-label" for="gkk-pref-' + r + '">Requested bead size <span class="gkk-req">— required</span></label><input class="gkk-input" id="gkk-pref-' + r + '" type="text" maxlength="40" required aria-required="true" autocomplete="off" data-pref="' + r + '" value="' + esc(s.pref || '') + '" placeholder="For example 20–22 mm"></div>';
        } else {
          var opts = sizeOptions(cur);
          if (!opts.length) html += '<p class="gkk-help">No size of this bead is offered online right now. Please choose another origin or ask us on WhatsApp.</p>';
          else html += '<fieldset class="gkk-sizes"' + (res.state === 'size' ? ' data-size-needed' : '') + '><legend class="gkk-label">Select bead size <span class="gkk-req">— required</span> <button type="button" class="gkk-info" data-info-open="sizes" aria-label="About bead sizes">i</button></legend><div class="gkk-sizes__list">' + opts.map(function (o) {
            var tag = o.quote ? 'Ask for availability' : !o.purchasable ? (o.unavailable ? 'Unavailable' : 'Price pending') : money(o.price);
            return '<label class="gkk-size' + (o.purchasable ? '' : ' is-quote') + '"><input type="radio" name="gkk-size-' + r + '" value="' + esc(o.size) + '"' + (s && s.size === o.size ? ' checked' : '') + '><span><span class="gkk-size__mm">' + esc(sizeText(o.size)) + '</span><span class="gkk-size__price">' + esc(tag) + '</span></span></label>';
          }).join('') + '</div></fieldset>';
        }
      }
    }
    li.innerHTML = html;
    li.setAttribute('data-state', res.state);
    if (isDone(res.state)) li.classList.remove('is-attention');
  }
  function renderProgress() {
    var rs = roles(), n = doneCount();
    var q = rs.filter(function (r) { return resolve(r).state === 'quote'; }).length;
    $('[data-progress]').innerHTML = '<strong>' + n + ' of ' + rs.length + ' main beads completed</strong>' + (q ? ' · ' + plural(q, 'bead', 'beads') + ' to be quoted' : '') + '<span class="gkk-progress__bar" aria-hidden="true"><span style="width:' + (rs.length ? (n / rs.length) * 100 : 0) + '%"></span></span>';
  }

  /* ---------- step 4: base ---------- */
  function renderBases() {
    $$('input[name="gkk-chain"]').forEach(function (i) { i.checked = i.value === S.chain; });
    var wrap = $('[data-chain-beads]'); if (wrap) wrap.hidden = S.chain === 'thread';
    $('[data-bases]').innerHTML = BASE_ORDER.map(function (k) {
      var b = BASES[k], on = S.bases.indexOf(k) > -1;
      var price = b.nepal ? (function () { var v = npVariant(b.nepal, S.baseSize); return v ? '+' + money(v.price) + ' per bead' : 'Not available in ' + S.baseSize + ' mm'; })() : 'In the Kantha price';
      return '<button type="button" class="gkk-card gkk-card--btn" data-base="' + k + '" aria-pressed="' + on + '"><span class="gkk-card__box">' + (b.img ? '<img class="gkk-card__img gkk-card__img--sq" src="' + esc(sized(b.img, 240)) + '" alt="' + esc(b.name) + '" width="120" height="120" loading="lazy">' : placeholder(b.name)) +
        '<span class="gkk-card__name">' + esc(b.name) + '</span><span class="gkk-card__desc">' + esc(b.line) + '</span><span class="gkk-card__price">' + esc(price) + '</span></span></button>';
    }).join('');
  }
  function renderBaseCalc(ev) {
    var c = ev.calc, el = $('[data-base-calc]');
    if (S.chain === 'thread') { el.textContent = 'Plain thread back chain: no back chain beads. Your main beads, Gauri Shankar and the 1 Mukhi stay the same.' + (S.length ? ' Made to ' + S.length + ' inches.' : ''); return; }
    if (!S.length) { el.textContent = 'No length chosen. Our team will confirm the length and the number of back chain beads with you.'; return; }
    if (c.over) { el.textContent = 'Your main beads are longer than ' + S.length + ' inches. Choose a longer Kantha.'; return; }
    if (!S.bases.length) { el.textContent = 'Choose at least one kind of back chain bead, or choose Plain thread.'; return; }
    el.textContent = 'About ' + c.fill + ' back chain beads of ' + S.baseSize + ' mm for ' + S.length + ' inches' + (S.bases.length > 1 ? ', alternating' : '') + (c.approx ? ' (approximate until every main bead size is chosen)' : '') + '.';
  }

  /* ---------- step 5: construction ---------- */
  function renderBuilds() {
    var imgs = DATA.images || {};
    $('[data-builds]').innerHTML = BUILDS.map(function (b) {
      var img = imgs[b.img] ? '<img class="gkk-card__img" src="' + esc(sized(imgs[b.img], 600)) + '" alt="' + esc(b.name) + '" width="300" height="225" loading="lazy">' : placeholder(b.name);
      var tag = b.key === 'dhaga' ? 'Basket price pending' : b.key === 'cap-thread' ? (DATA.fullCapping && DATA.capBig ? money(DATA.fullCapping.price) + ' + ' + money(DATA.capBig.price) + ' per main bead' : 'Price pending') : 'Quotation';
      return '<label class="gkk-card"><input type="radio" name="gkk-build" value="' + b.key + '"' + (S.build === b.key ? ' checked' : '') + '><span class="gkk-card__box">' + img + '<span class="gkk-card__name">' + esc(b.name) + '</span><span class="gkk-card__desc">' + esc(b.desc) + '</span><span class="gkk-card__price">' + esc(tag) + '</span></span></label>';
    }).join('') + '<p class="gkk-help gkk-span"><button type="button" class="gkk-link" data-info-open="build">How each option is made</button></p>';
    renderBuildExtra();
  }
  function renderBuildExtra() {
    var b = build(), host = $('[data-build-extra]'), html = '';
    if (b && b.basket) html += '<div class="gkk-basket">' + placeholder('1 Mukhi basket') + '<div><p class="gkk-label">1 Mukhi basket <span class="gkk-badge">Included with this option</span></p><p class="gkk-help">The 1 Mukhi sits in a basket fitting. It is part of this option and cannot be removed. Its price is being set up, so this Kantha is quoted by our team.</p></div></div>';
    if (b && b.thread) html += '<fieldset class="gkk-field"><legend class="gkk-label">Thread colour</legend><div class="gkk-swatches">' + COLOURS.map(function (c) { return '<label class="gkk-swatch"><input type="radio" name="gkk-colour" value="' + c + '"' + (S.colour === c ? ' checked' : '') + '><span><i style="background:' + COLOUR_HEX[c] + '"></i>' + c + '</span></label>'; }).join('') + '</div></fieldset>';
    if (b && b.key === 'all-silver') html += '<fieldset class="gkk-field"><legend class="gkk-label">Silver design</legend><div class="gkk-cards gkk-cards--three">' + SILVER_DESIGNS.map(function (d) { return '<label class="gkk-card"><input type="radio" name="gkk-silver" value="' + d.key + '"' + (S.silverDesign === d.key ? ' checked' : '') + '><span class="gkk-card__box">' + placeholder(d.name) + '<span class="gkk-card__name">' + esc(d.name) + '</span><span class="gkk-card__price">Price pending</span></span></label>'; }).join('') + '</div></fieldset>';
    host.innerHTML = html;
  }

  /* ---------- step 6: extras ---------- */
  function renderEnergy() {
    $('[data-energy]').innerHTML = energyChoices().map(function (e) {
      var tag = e.price ? '+' + money(e.price) : e.key === 'none' ? '₹0' : '<span class="gkk-badge">Included</span>';
      return '<label class="gkk-card gkk-card--text"><input type="radio" name="gkk-energy" value="' + e.key + '"' + (S.energy === e.key ? ' checked' : '') + (e.available === false ? ' disabled' : '') + '><span class="gkk-card__box"><span class="gkk-card__name">' + esc(e.title) + (e.available === false ? ' (sold out)' : '') + '</span>' + (e.desc ? '<span class="gkk-card__desc">' + esc(e.desc) + '</span>' : '') + '<span class="gkk-card__price">' + tag + '</span></span></label>';
    }).join('');
  }

  /* ---------- review ---------- */
  /* ---------- preview: a fixed V of main beads ----------
     Viewer's left arm, from its upper end down: 2, 4, 6 ... ; right arm: 3, Ganesh, 5, 7 ...
     The arms meet above Gauri Shankar; the 1 Mukhi hangs below Gauri Shankar (in its basket when the
     construction has one). Every main bead has a fixed slot, so changing a size, origin or product
     only redraws that bead. The back chain continues from the two upper ends, smaller, and may run past
     the top edge. Sizes scale the bead within its slot (illustrative, not to physical scale). */
  function armRoles() {
    var m = mala(); if (!m) return { left: [], right: [] };
    var left = [], right = ['3', 'ganesh'];
    for (var i = 2; i <= m.top; i += 2) left.push(String(i));
    for (var j = 5; j <= m.top; j += 2) right.push(String(j));
    return { left: left, right: right };
  }
  function previewLayout(labelled) {
    var arms = armRoles(), n = Math.max(arms.left.length, arms.right.length);
    var W = labelled ? 640 : 360, s = labelled ? (n > 8 ? 34 : 44) : (n > 8 ? 32 : 44);
    var th = 24 * Math.PI / 180, cx = W / 2, sin = Math.sin(th), cos = Math.cos(th);
    var topY = 1.5 * s, yA = topY + n * s * cos;
    var pos = {};
    function arm(list, side) {
      /* list runs from the upper end to the bottom; j = 0 is the bead nearest the centre */
      var m = list.length;
      list.slice().reverse().forEach(function (r, j) {
        var d = (1 + j) * s, t = d / ((1 + n - 1) * s), bulge = 0.18 * s * 4 * t * (1 - t);
        pos[r] = { x: cx + side * (d * sin + bulge * cos), y: yA - d * cos + bulge * sin * 0.4, slot: s, side: side, angle: side * th * 180 / Math.PI, idx: j, m: m };
      });
    }
    arm(arms.left, -1); arm(arms.right, 1);
    var yG = yA + 0.5 * s, y1 = yG + 0.68 * s + 0.35 * s + 0.6 * s;
    pos.gs = { x: cx, y: yG, slot: 1.36 * s, side: 1, angle: 0 };
    pos['1'] = { x: cx, y: y1, slot: 1.2 * s, side: -1, angle: 0 };
    var H = y1 + 0.6 * s + 0.75 * s;
    /* back chain: continues from each upper end, turning gently upwards, past the top edge */
    function chain(list, side) {
      var top = pos[list[0]] || { x: cx + side * s, y: yA - s }, pts = [], ang = th, x = top.x, y = top.y, step = 0.52 * s;
      x += side * Math.sin(ang) * (top.slot / 2 + 0.3 * s); y -= Math.cos(ang) * (top.slot / 2 + 0.3 * s);
      for (var k = 0; k < 40 && y > -s; k++) { pts.push({ x: x, y: y }); ang = Math.max(th * 0.25, ang - 0.05); x += side * Math.sin(ang) * step; y -= Math.cos(ang) * step; }
      return pts;
    }
    return { W: W, H: H, s: s, cx: cx, pos: pos, arms: arms, chainL: chain(arms.left, -1), chainR: chain(arms.right, 1), labelled: labelled };
  }
  function beadView(r) {
    var x = resolve(r), b = x.bead || (S.sel[r] && BEADS[S.sel[r].key]) || null;
    var size = x.opt && x.opt.size ? sizeText(x.opt.size) : (x.state === 'quote' && x.pref ? 'Requested ' + x.pref : null);
    var mm = x.opt && x.opt.size ? sizeMid(x.opt.size) : (b && b.approxMm) || 0;
    return { role: r, bead: b, img: b ? b.img : '', name: roleName(r), sizeLabel: size || 'Size not selected', hasSize: !!size, mm: mm, origin: b ? b.originLabel : '' };
  }
  function shortTag(r) { return r === 'gs' ? 'GS' : r === 'ganesh' ? 'G' : r; }
  function threadColour() {
    var b = build();
    if (b && b.thread) return COLOUR_HEX[S.colour] || '#8a6a3a';
    if (b) return '#a9abb0';
    return '#b8a07a';
  }
  function renderPreviewInto(host, labelled) {
    if (!host) return;
    var L = previewLayout(labelled), W = L.W, H = L.H, s = L.s;
    var views = {}; roles().forEach(function (r) { views[r] = beadView(r); });
    var mms = Object.keys(views).map(function (r) { return views[r].mm; }).filter(Boolean);
    var lo = mms.length ? Math.min.apply(null, mms) : 0, hi = mms.length ? Math.max.apply(null, mms) : 0;
    function diam(r, slot) { var v = views[r]; if (!v || !v.mm || hi === lo) return slot * 0.86; return slot * (0.7 + 0.3 * (v.mm - lo) / (hi - lo)); }
    var b = build(), capped = !!(b && b.key !== 'dhaga'), basket = !!(b && b.basket);
    var thread = S.chain === 'thread', col = threadColour();
    var pct = function (v, of) { return (v / of * 100).toFixed(3) + '%'; };
    var svg = '<svg class="gkk-v__svg" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true" focusable="false">';
    /* the string: back chain, both arms and Gauri Shankar, drawn only in the gaps between beads */
    var chainR = thread ? 0 : 0.2 * s;
    var nodes = L.chainL.slice().reverse().map(function (p) { return { x: p.x, y: p.y, r: chainR }; });
    L.arms.left.forEach(function (r) { var p = L.pos[r]; nodes.push({ x: p.x, y: p.y, r: diam(r, p.slot) * 0.42 }); });
    nodes.push({ x: L.pos.gs.x, y: L.pos.gs.y, r: diam('gs', L.pos.gs.slot) * 0.42 });
    L.arms.right.slice().reverse().forEach(function (r) { var p = L.pos[r]; nodes.push({ x: p.x, y: p.y, r: diam(r, p.slot) * 0.42 }); });
    L.chainR.forEach(function (p) { nodes.push({ x: p.x, y: p.y, r: chainR }); });
    var segs = '';
    for (var ni = 1; ni < nodes.length; ni++) {
      var p1 = nodes[ni - 1], p2 = nodes[ni], dx = p2.x - p1.x, dy = p2.y - p1.y, len = Math.hypot(dx, dy);
      if (len <= p1.r + p2.r) continue;
      var ux = dx / len, uy = dy / len;
      segs += 'M' + (p1.x + ux * p1.r).toFixed(1) + ' ' + (p1.y + uy * p1.r).toFixed(1) + 'L' + (p2.x - ux * p2.r).toFixed(1) + ' ' + (p2.y - uy * p2.r).toFixed(1);
    }
    svg += '<path d="' + segs + '" fill="none" stroke="' + col + '" stroke-width="' + (thread ? 1.6 : 1.1) + '" stroke-linecap="round"/>';
    var g = L.pos.gs, one = L.pos['1'];
    var gr = diam('gs', g.slot) * 0.42, or = diam('1', one.slot) * (basket ? 0.62 : 0.42);
    svg += '<line x1="' + g.x + '" y1="' + (g.y + gr) + '" x2="' + one.x + '" y2="' + (one.y - or - (basket ? 6 : 0)) + '" stroke="' + (basket ? '#9a9da3' : col) + '" stroke-width="1.4"/>';
    var basketSvg = '';
    if (basket) {
      /* a wire cage hugging the 1 Mukhi: top ring, cap, and curved wires meeting below */
      var od = diam('1', one.slot), rx = od * 0.56, ry = od * 0.56, cy = one.y, top = cy - ry;
      basketSvg = '<svg class="gkk-v__svg gkk-v__svg--top" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true" focusable="false"><g class="gkk-basket-svg" fill="none" stroke="#8f9399" stroke-width="1.3" stroke-linecap="round">' +
        '<circle cx="' + one.x + '" cy="' + (top - 4) + '" r="2.6"/>' +
        '<path d="M' + (one.x - rx * 0.45) + ' ' + (top + 1) + ' Q' + one.x + ' ' + (top - 4) + ' ' + (one.x + rx * 0.45) + ' ' + (top + 1) + '"/>' +
        [-1, -0.45, 0.45, 1].map(function (k) { return '<path d="M' + (one.x + k * rx * 0.45) + ' ' + (top + 1) + ' Q' + (one.x + k * rx * 1.25) + ' ' + cy + ' ' + one.x + ' ' + (cy + ry + 2) + '"/>'; }).join('') +
        '<circle cx="' + one.x + '" cy="' + (cy + ry + 3) + '" r="1.6" fill="#8f9399"/></g></svg>';
    }
    /* label leader lines */
    var labels = '';
    if (labelled) {
      /* label columns sit just outside the widest bead of each arm */
      var minX = W, maxX = 0;
      L.arms.left.concat(L.arms.right).forEach(function (r) { var p = L.pos[r]; minX = Math.min(minX, p.x - p.slot / 2); maxX = Math.max(maxX, p.x + p.slot / 2); });
      var colL = minX - 10, colR = maxX + 10;
      Object.keys(views).forEach(function (r) {
        var p = L.pos[r]; if (!p) return;
        var d = diam(r, p.slot), left = r === '1' ? true : r === 'gs' ? false : p.side < 0;
        var x1 = left ? colL : colR, x2 = left ? p.x - d / 2 - 3 : p.x + d / 2 + 3;
        svg += '<line class="gkk-leader" x1="' + x1 + '" y1="' + p.y + '" x2="' + x2 + '" y2="' + p.y + '"/>';
        var v = views[r];
        labels += '<span class="gkk-vlabel gkk-vlabel--' + (left ? 'l' : 'r') + '" style="top:' + pct(p.y, H) + ';' + (left ? 'right:' + pct(W - colL + 6, W) : 'left:' + pct(colR + 6, W)) + '"><b>' + esc(v.name) + '</b><span' + (v.hasSize ? '' : ' class="is-missing"') + '>' + esc(v.sizeLabel) + '</span></span>';
      });
    }
    svg += '</svg>';
    var html = svg;
    /* back chain beads (secondary) */
    if (!thread) {
      var imgs = activeBases().map(function (k) { return BASES[k] && BASES[k].img; }).filter(Boolean);
      var bd = 0.4 * s;
      [L.chainL, L.chainR].forEach(function (pts) {
        pts.forEach(function (p, i) { if (i % 1) return; html += '<span class="gkk-cb" style="left:' + pct(p.x, W) + ';top:' + pct(p.y, H) + ';width:' + pct(bd, W) + '">' + (imgs.length ? '<img src="' + esc(sized(imgs[i % imgs.length], 60)) + '" alt="" loading="lazy">' : '') + '</span>'; });
      });
    }
    /* main beads in fixed slots */
    Object.keys(views).forEach(function (r) {
      var p = L.pos[r]; if (!p) return;
      var v = views[r], d = diam(r, p.slot);
      var label = v.name + (v.origin ? ', ' + v.origin : '') + ', ' + v.sizeLabel;
      html += '<button type="button" class="gkk-mb' + (v.bead ? '' : ' is-empty') + (capped ? ' is-capped' : '') + (r === 'gs' ? ' gkk-mb--gs' : '') + (r === '1' ? ' gkk-mb--one' : '') + '" data-bead-info="' + esc(r) + '" style="left:' + pct(p.x, W) + ';top:' + pct(p.y, H) + ';width:' + pct(d, W) + ';--rot:' + (p.angle || 0) + 'deg" aria-label="' + esc(label) + '">' +
        (v.img ? '<img src="' + esc(sized(v.img, 160)) + '" alt="" loading="lazy">' : '') + (capped ? '<i class="gkk-mb__cap" aria-hidden="true"></i>' : '') +
        (labelled ? '' : '<span class="gkk-mb__tag gkk-mb__tag--' + (r === '1' || r === 'gs' ? 'c' : (p.side < 0 ? 'out-l' : 'out-r')) + '" aria-hidden="true">' + esc(shortTag(r)) + '</span>') + '</button>';
    });
    html += basketSvg + labels;
    host.className = 'gkk-v' + (labelled ? ' gkk-v--labelled' : ' gkk-v--compact');
    host.style.aspectRatio = W + ' / ' + H;
    host.innerHTML = html;
  }
  function renderPreview(ev) {
    var host = $('[data-preview]');
    var wide = (host.parentNode.clientWidth || 0) >= 600;
    renderPreviewInto(host, wide);
    var zoom = $('[data-preview-zoom]'); if (zoom) zoom.hidden = wide;
    var m = mala();
    var fill = ev.calc.fill || 0, thread = S.chain === 'thread';
    var cap = m ? m.name + ': ' + roles().filter(function (r) { return beadView(r).bead; }).length + ' of ' + roles().length + ' main beads' + (thread ? ', plain thread back chain' : (fill ? ', about ' + fill + ' back chain beads' : (S.length ? '' : activeBases().length ? ', back chain beads to the length we confirm with you' : ''))) + (S.length ? ', ' + S.length + ' in' : '') + (build() ? ', ' + build().name : '') : '';
    $('[data-preview-caption]').textContent = cap;
    host.setAttribute('aria-label', 'Kantha preview. ' + cap);
  }
  function showBeadInfo(r) {
    var v = beadView(r), el = $('[data-preview-detail]');
    if (!el) return;
    el.innerHTML = '<strong>' + esc(v.name) + '</strong>' + (v.origin ? ' · ' + esc(v.origin) : '') + ' · <span' + (v.hasSize ? '' : ' class="is-missing"') + '>' + esc(v.sizeLabel) + '</span>';
  }
  function beadDetail(r) { var x = resolve(r); if (!x.bead) return 'not chosen'; return x.bead.originLabel + (x.bead.sourceNote ? ' (' + x.bead.sourceNote + ')' : '') + (x.opt && x.opt.size ? ', ' + sizeText(x.opt.size) : x.state === 'quote' && x.pref ? ', requested size ' + x.pref : '') + (x.state === 'quote' ? ' (' + x.reason + ')' : x.state === 'size' ? ' (size to choose)' : x.state === 'include' ? ' (not yet included)' : ''); }
  /* grouped = consecutive places with the same detail share one line (screen); otherwise one entry per place (orders, quotations) */
  function mainBeadText(grouped) {
    var rs = roles();
    if (!grouped) return rs.map(function (r) { return roleName(r) + ': ' + beadDetail(r); }).join('; ');
    var out = [], start = 0;
    for (var i = 1; i <= rs.length; i++) {
      if (i < rs.length && beadDetail(rs[i]) === beadDetail(rs[start]) && /^\d+$/.test(rs[i]) && /^\d+$/.test(rs[start])) continue;
      var a = rs[start], b = rs[i - 1];
      var label = a === b ? roleName(a) : a + ' to ' + b + ' Mukhi';
      out.push(label + ': ' + beadDetail(a));
      start = i;
    }
    return out.join('; ');
  }
  function summaryRows(ev, grouped) {
    var m = mala(), o = origin(), b = build();
    var rows = [];
    rows.push(['Mala', m ? m.name + ' (' + roles().length + ' main beads)' : null]);
    rows.push(['Origin', o ? o.name : null]);
    rows.push(['Main beads', mainBeadText(!!grouped)]);
    rows.push(['Length', S.length ? S.length + ' in' : 'No preference (our team will confirm)']);
    rows.push(['Back chain', S.chain === 'thread' ? 'Plain thread' : S.bases.length ? 'Back chain beads: ' + S.bases.map(function (k) { return BASES[k] ? BASES[k].name : k; }).join(' + ') + ', ' + S.baseSize + ' mm' + (S.length ? ', about ' + ev.calc.fill + ' beads' : ', number to match the confirmed length') : null]);
    rows.push(['Construction', b ? b.name + (b.basket ? ' (1 Mukhi basket included)' : '') + (b.key === 'all-silver' && S.silverDesign ? ', ' + SILVER_DESIGNS.filter(function (d) { return d.key === S.silverDesign; })[0].name : '') : null]);
    if (b && b.thread) rows.push(['Thread colour', S.colour]);
    rows.push(['GJSPC report', m ? m.reportName + ', included free (value ' + money(m.reportValue) + ')' : 'Included free']);
    var en = energyOpt();
    rows.push(['Energisation', en.label]);
    if (S.note.trim()) rows.push(['Note', S.note.trim()]);
    if (S.design) rows.push(['Design file', S.design.name]);
    return rows;
  }
  function renderReview() {
    var ev = evaluate();
    $('[data-report]').innerHTML = reportHtml(false);
    $('[data-review-summary]').innerHTML = summaryRows(ev, true).map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd' + (r[1] == null ? ' class="is-missing"' : '') + '>' + esc(r[1] == null ? 'Not chosen' : r[1]) + '</dd>'; }).join('');
    var lines = ev.known.map(function (x) { return '<div class="gkk-bd"><span>' + esc(x.label) + '</span><span>' + money(x.amount) + '</span></div>'; }).join('');
    var m = mala();
    lines += '<div class="gkk-bd"><span>GJSPC Laboratory report' + (m ? ' (value ' + money(m.reportValue) + ')' : '') + '</span><span>Included free</span></div>';
    if (ev.todo.length) {
      lines += '<div class="gkk-bd gkk-bd--total gkk-bd--partial"><span>Subtotal so far (not final)</span><span>' + money(ev.subtotal) + '</span></div><p class="gkk-help">Your design is not complete yet, so this is not a total.</p>';
      if (ev.quote.length) lines += '<p class="gkk-help">It also leaves out these items, which our team quotes:</p><ul class="gkk-quote-list">' + ev.quote.map(function (q) { return '<li>' + esc(q) + '</li>'; }).join('') + '</ul>';
    } else if (ev.quote.length) {
      lines += '<div class="gkk-bd gkk-bd--total gkk-bd--partial"><span>Known subtotal (not final)</span><span>' + money(ev.subtotal) + '</span></div><p class="gkk-help">The subtotal does not include the items below, which our team quotes:</p><ul class="gkk-quote-list">' + ev.quote.map(function (q) { return '<li>' + esc(q) + '</li>'; }).join('') + '</ul>';
    } else {
      lines += '<div class="gkk-bd gkk-bd--total"><span>Total</span><span>' + money(ev.subtotal) + '</span></div>';
    }
    $('[data-breakdown]').innerHTML = lines;
    var acts = '';
    if (ev.todo.length) acts += '<p class="gkk-help">Still to choose: ' + esc(ev.todo.map(function (t) { return t.msg; }).join(' ')) + '</p>';
    if (ev.quote.length) acts += '<button type="button" class="gkk-btn gkk-btn--primary gkk-btn--block" data-quote>Request availability and quotation</button><button type="button" class="gkk-btn gkk-btn--secondary gkk-btn--block" data-copy>Copy my design details</button><p class="gkk-help">This opens WhatsApp with your full design. Nothing is charged until we confirm the price with you.</p>';
    else acts += '<button type="button" class="gkk-btn gkk-btn--primary gkk-btn--block" data-buy>Add Kantha to cart</button>';
    $('[data-actions]').innerHTML = acts;
    renderPreview(ev);
  }

  /* ---------- flow: sections stay open once reached ----------
     Single-choice sections (Mala, origin, construction) open the next section when first completed.
     The main beads section stays open until every bead is complete; each first-time completed bead
     moves on to the next incomplete bead. Optional sections (back chain, energisation and note) never
     block: reaching them also opens the section after them. Nothing is auto-selected to progress,
     and only a first-time completion scrolls; later changes update in place. */
  var OPENED = { mala: true }, FIRST = {};
  var STEP_NAMES = { mala: 'Mala', origin: 'origin', beads: 'main beads', base: 'length and back chain', build: 'construction', extras: 'energisation', review: 'review' };
  function stepComplete(step, ev) {
    if (step === 'mala') return !!mala();
    if (step === 'origin') return !!origin();
    if (step === 'extras') return true;
    if (step === 'review') return false;
    if ((step === 'beads' || step === 'base' || step === 'build') && (!mala() || !origin())) return false;
    return !ev.todo.some(function (x) { return x.step === step; });
  }
  function renderBody(step) {
    if (step === 'beads') renderRoles();
    if (step === 'base') renderBases();
    if (step === 'build') renderBuilds();
  }
  function renderFlow() {
    var ev = evaluate();
    STEPS.forEach(function (step) {
      var sec = $('[data-step="' + step + '"]'), body = $('[data-body="' + step + '"]');
      var open = !!OPENED[step];
      body.hidden = !open;
      sec.classList.toggle('is-open', open);
      sec.classList.toggle('is-locked', !open);
      var complete = open && step !== 'review' && stepComplete(step, ev);
      sec.classList.toggle('is-done', complete);
      sec.classList.toggle('is-invalid', open && !!FIRST[step] && !complete && step !== 'review');
    });
    if (OPENED.beads) renderProgress();
    if (OPENED.base) renderBaseCalc(ev);
    if (OPENED.review) renderReview();
    renderBar(ev);
  }
  /* Called after a change in a section. Opens what comes next the first time the section is complete. */
  function progress(step, scroll) {
    var ev = evaluate();
    if (FIRST[step] || !stepComplete(step, ev)) { renderFlow(); return; }
    FIRST[step] = true;
    var target = null;
    for (var i = STEPS.indexOf(step) + 1; i < STEPS.length; i++) {
      var s = STEPS[i];
      if (!OPENED[s]) { OPENED[s] = true; renderBody(s); if (!target) target = s; }
      if (s === 'review' || !stepComplete(s, ev)) break;
      FIRST[s] = true; /* optional sections that are already complete: pass through without a later jump */
    }
    renderFlow();
    if (target && scroll !== false) scrollToStep(target);
  }
  /* ----- gentle scrolling below the sticky site header and above the bottom bar ----- */
  var scrollRaf = 0;
  function headerBottom() {
    /* only a header that really stays on screen (sticky or fixed) covers content */
    var h = document.querySelector('.shopify-section-header-sticky') || document.querySelector('.section-header') || document.querySelector('sticky-header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 && r.bottom < window.innerHeight / 2 ? r.bottom : 0;
  }
  function barHeight() { var bar = $('[data-bar]'); return bar && !bar.hidden ? bar.getBoundingClientRect().height : 0; }
  function scrollToEl(el, mode, focusEl) {
    if (!el) return;
    if (scrollRaf) cancelAnimationFrame(scrollRaf);
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = 0;
      var r = el.getBoundingClientRect(), top = headerBottom(), y;
      if (mode === 'center') {
        var room = window.innerHeight - top - barHeight();
        y = window.scrollY + r.top - top - Math.max(12, (room - r.height) / 2);
      } else {
        y = window.scrollY + r.top - top - 56; /* keep the end of the previous section in view */
      }
      window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' });
      if (focusEl) focusEl.focus({ preventScroll: true });
    });
  }
  function scrollToStep(step) {
    var sec = $('[data-step="' + step + '"]');
    scrollToEl(sec, 'top', sec && $('.gkk-step__title', sec));
  }
  function syncStickyTop() { root.style.setProperty('--gkk-sticky-top', headerBottom() + 'px'); }
  /* After a bead place is completed for the first time, move to the next incomplete place. */
  function roleDone(r, scroll) {
    if (FIRST['role:' + r] || !isDone(resolve(r).state)) return;
    FIRST['role:' + r] = true;
    var ev = evaluate();
    if (stepComplete('beads', ev)) { progress('beads', scroll); return; }
    if (scroll === false) return;
    var rs = roles(), i = rs.indexOf(r), nextR = null;
    for (var j = 1; j <= rs.length; j++) { var c = rs[(i + j) % rs.length]; if (!isDone(resolve(c).state)) { nextR = c; break; } }
    if (nextR) scrollToEl($('[data-role="' + nextR + '"]'), 'center', firstInput(nextR));
  }
  function firstInput(r) {
    var li = $('[data-role="' + r + '"]'); if (!li) return null;
    var st = resolve(r).state;
    return st === 'empty' ? $('input[name="gkk-bead-' + r + '"]', li) : st === 'include' ? $('[data-include]', li) : $('[data-pref]', li) || $('.gkk-sizes input', li);
  }
  /* The first required choice that is still missing, in section order. */
  function firstMissing(ev) {
    return ev.todo.slice().sort(function (a, b) { return STEPS.indexOf(a.step) - STEPS.indexOf(b.step); })[0] || null;
  }
  function goToMissing(ev) {
    var t = firstMissing(ev); if (!t) return;
    if (!OPENED[t.step]) { OPENED[t.step] = true; renderBody(t.step); renderFlow(); }
    if (t.step === 'beads' && t.role) { focusRole(t.role); return; }
    flash(t.step, t.msg);
    scrollToStep(t.step);
  }
  function focusRole(r) {
    var li = $('[data-role="' + r + '"]');
    if (!li) return;
    li.classList.add('is-attention');
    scrollToEl(li, 'center', firstInput(r));
  }
  function flash(step, msg) {
    var body = $('[data-body="' + step + '"]');
    var el = $('.gkk-inline-error', body);
    if (!el) { el = document.createElement('p'); el.className = 'gkk-inline-error'; el.setAttribute('role', 'alert'); body.appendChild(el); }
    el.textContent = msg;
  }
  function clearFlash(step) { var el = $('[data-body="' + step + '"] .gkk-inline-error'); if (el) el.remove(); }

  /* ---------- sticky bar ---------- */
  function renderBar(ev) {
    var bar = $('[data-bar]');
    var m = mala();
    if (!m) { bar.hidden = true; root.classList.remove('has-bar'); return; }
    bar.hidden = false; root.classList.add('has-bar');
    var n = doneCount();
    $('[data-bar-main]').textContent = (ev.purchasable ? 'Total ' : 'So far ') + money(ev.subtotal);
    $('[data-bar-sub]').textContent = m.name + ', ' + n + ' of ' + roles().length + ' main beads completed' + (ev.quote.length ? ', quotation needed' : '');
    var t = firstMissing(ev);
    $('[data-bar-cta]').textContent = t ? 'Next: ' + STEP_NAMES[t.step] : 'Review';
  }

  /* ---------- quotation ---------- */
  function designText(ev) {
    var lines = ['Hi GemKrishna, I would like a quotation for this custom Rudraksha Kantha:'];
    summaryRows(ev).forEach(function (r) { lines.push(r[0] + ': ' + (r[1] == null ? 'not chosen' : r[1])); });
    lines.push('Known subtotal: ' + money(ev.subtotal) + ' (excludes the items below)');
    if (ev.quote.length) lines.push('Please quote: ' + ev.quote.join('; '));
    lines.push('Reference: ' + buildRef);
    return lines.join('\n');
  }

  /* ---------- cart ---------- */
  function productJSON(handle) { return fetchJSON(ROUTE_ROOT + 'products/' + encodeURIComponent(handle) + '.js').catch(function () { throw new Error('We could not check the latest prices. Please refresh the page and try again.'); }); }
  function check(json, id, price, label) {
    var v = ((json && json.variants) || []).filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v || !v.available) throw new Error(label + ' is not available right now. Please change it or ask us on WhatsApp.');
    if (Number(v.price) !== Number(price)) throw new Error('The price of ' + label + ' has changed since this page opened. Please refresh the page.');
    return v.id;
  }
  function buy() {
    if (busy) return;
    var ev = evaluate();
    if (!ev.purchasable) { var miss = firstMissing(ev); message(miss ? miss.msg : 'This Kantha needs a quotation.', 'error'); if (miss) goToMissing(ev); return; }
    busy = true; setBusy(true);
    var m = mala(), o = origin(), b = build();
    var ref = buildRef;
    var link = function (extra) { var p = { 'For kantha': ref }; p[PRIVATE_REF_KEY] = ref; Object.keys(extra || {}).forEach(function (k) { p[k] = extra[k]; }); return p; };
    var props = {};
    summaryRows(ev).forEach(function (r) { if (r[1] != null) props[r[0]] = String(r[1]).slice(0, 900); });
    props['Kantha ref'] = ref;
    props['_gk_builder'] = 'custom-rudraksha-kantha-v3';
    props[PRIVATE_REF_KEY] = ref;
    var checks = [], items = [], handles = {};
    function need(h) { if (!handles[h]) handles[h] = productJSON(h); return handles[h]; }
    checks.push(need(DATA.body.handle).then(function (j) { items.push({ o: 0, it: { id: check(j, ev.body.id, ev.body.price, 'the Kantha making'), quantity: 1, properties: props } }); }));
    roles().forEach(function (r, i) {
      var x = resolve(r);
      checks.push(need(x.bead.product.handle).then(function (j) { items.push({ o: 10 + i, it: { id: check(j, x.opt.variantId, x.opt.price, roleName(r) + ' (' + x.bead.originLabel + ')'), quantity: 1, properties: link({ 'Type': roleName(r) + ' Rudraksha', 'Origin': x.bead.originLabel + (x.bead.sourceNote ? ' (' + x.bead.sourceNote + ')' : ''), 'Bead size': sizeText(x.opt.size) }) } }); }));
    });
    ev.baseLines.lines.forEach(function (l, i) {
      checks.push(need(DATA.npBase.handle).then(function (j) { items.push({ o: 100 + i, it: { id: check(j, l.variantId, l.each, l.name), quantity: l.n, properties: link({ 'Used as': 'Back chain beads', 'Size': S.baseSize + ' mm' }) } }); }));
    });
    if (b.key === 'cap-thread') {
      checks.push(need(DATA.fullCapping.handle).then(function (j) { items.push({ o: 200, it: { id: check(j, DATA.fullCapping.id, DATA.fullCapping.price, '925 silver capping'), quantity: 1, properties: link({}) } }); }));
      checks.push(need(DATA.capBig.handle).then(function (j) { items.push({ o: 201, it: { id: check(j, DATA.capBig.id, DATA.capBig.price, 'silver caps'), quantity: roles().length, properties: link({ 'Rudraksha capped': String(roles().length) }) } }); }));
    }
    var en = energyOpt();
    if (en.price) checks.push(need(en.handle).then(function (j) { items.push({ o: 300, it: { id: check(j, en.id, en.price, en.title), quantity: 1, properties: link({}) } }); }));
    var sent;
    Promise.all(checks).then(function () {
      items.sort(function (a, c) { return a.o - c.o; });
      sent = items.map(function (x) { return x.it; });
      return fetchJSON(ROUTE_ROOT + 'cart.js');
    }).then(function (cart) {
      var up = {}, n = 0;
      ((cart && cart.items) || []).forEach(function (l) { if (l.properties && l.properties[PRIVATE_REF_KEY] === ref) { up[l.key] = 0; n++; } });
      return n ? postJSON('cart/update.js', { updates: up }) : null;
    }).then(function () {
      if (!S.design) return postJSON('cart/add.js', { items: sent });
      var first = sent[0], fd = new FormData();
      fd.append('id', String(first.id)); fd.append('quantity', '1');
      Object.keys(first.properties).forEach(function (k) { fd.append('properties[' + k + ']', first.properties[k]); });
      fd.append('properties[Your design]', S.design, S.design.name);
      return fetchJSON(ROUTE_ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd }).then(function (r1) {
        return postJSON('cart/add.js', { items: sent.slice(1) }).then(function (r2) { return { items: [].concat(r1 && r1.items ? r1.items : [r1], (r2 && r2.items) || []) }; });
      });
    }).then(function (res) {
      var got = {}; ((res && res.items) || []).forEach(function (it) { if (it) got[it.variant_id] = (got[it.variant_id] || 0) + Number(it.quantity || 0); });
      var ok = sent.every(function (it) { return (got[it.id] || 0) >= it.quantity; });
      if (!ok) {
        var keys = {}; ((res && res.items) || []).forEach(function (it) { if (it) keys[it.key] = 0; });
        return postJSON('cart/update.js', { updates: keys }).catch(function () {}).then(function () { throw new Error('Some items could not be added, so nothing was added. Please try again or ask us on WhatsApp.'); });
      }
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch (e) { /* ignore */ }
      message('Added to your cart. Opening your cart…', 'ok');
      window.location.href = ROUTE_ROOT + 'cart';
      /* if the cart page does not open, let the customer continue; adding again replaces this build */
      window.setTimeout(function () { busy = false; setBusy(false); var mm = $('[data-message]'); if (mm) { mm.setAttribute('data-type', 'ok'); mm.innerHTML = 'Added to your cart. <a href="' + esc(ROUTE_ROOT + 'cart') + '">View cart</a>'; } }, 6000);
      /* if the cart page does not open, let the customer continue; adding again replaces this build */
      window.setTimeout(function () { busy = false; setBusy(false); var m = $('[data-message]'); if (m) { m.innerHTML = 'Added to your cart. <a href="' + esc(ROUTE_ROOT + 'cart') + '">View cart</a>'; m.setAttribute('data-type', 'ok'); } }, 6000);
    }).catch(function (err) {
      busy = false; setBusy(false);
      message((err && err.message) || 'Something went wrong. Please try again or ask us on WhatsApp.', 'error');
    });
  }
  function setBusy(on) { $$('[data-buy]').forEach(function (b) { b.disabled = on; b.textContent = on ? 'Adding…' : 'Add Kantha to cart'; if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); }); }
  function message(t, type) { var m = $('[data-message]'); m.textContent = t || ''; m.setAttribute('data-type', type || ''); }

  /* ---------- dialog ---------- */
  var lastTrigger = null;
  function openLabelledPreview(trigger) {
    var dlg = $('[data-dialog]'); if (!dlg || typeof dlg.showModal !== 'function') return;
    $('#gkk-dialog-title').textContent = 'Labelled preview';
    var body = $('[data-dialog-body]'); body.innerHTML = '<div class="gkk-v-scroll"><div class="gkk-v" role="group"></div></div><p class="gkk-help">Scroll sideways on a small screen to see every label.</p>';
    var host = $('.gkk-v', body); renderPreviewInto(host, true); host.setAttribute('aria-label', $('[data-preview]').getAttribute('aria-label'));
    lastTrigger = trigger; dlg.showModal(); $('[data-close]', dlg).focus();
  }
  function openInfo(key, trigger) {
    var tpl = $('template[data-info="' + key + '"]'), dlg = $('[data-dialog]');
    if (!tpl || !dlg || typeof dlg.showModal !== 'function') return;
    $('#gkk-dialog-title').textContent = tpl.getAttribute('data-title');
    var body = $('[data-dialog-body]'); body.innerHTML = ''; body.appendChild(tpl.content.cloneNode(true));
    lastTrigger = trigger; dlg.showModal(); $('[data-close]', dlg).focus();
  }

  /* ---------- events ---------- */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'gkk-mala') {
      var had = S.mala;
      S.mala = t.value;
      var d = (had && had !== S.mala && S.origin) ? reconcile() : (S.origin ? reconcile() : []);
      renderMalaDetail();
      if (d.length) $('[data-mala-detail]').insertAdjacentHTML('afterbegin', '<p class="gkk-notice" role="status">These places are not part of the ' + esc(mala().name) + ' and were removed: ' + esc(d.join('; ')) + '.</p>');
      if (OPENED.beads) renderRoles();
      if (OPENED.build) renderBuilds();
      clearFlash('mala'); progress('mala'); return;
    }
    if (t.name === 'gkk-origin') {
      S.origin = t.value;
      reconcile('origin choice');
      if (OPENED.beads) renderRoles();
      clearFlash('origin'); progress('origin'); return;
    }
    var m = t.name && t.name.match(/^gkk-bead-(.+)$/);
    if (m) { var b = BEADS[t.value]; S.sel[m[1]] = { key: b.key, size: null, pref: '', include: false }; renderRole(m[1]); renderProgress(); clearFlash('beads'); renderFlow(); var back = $('input[name="' + t.name + '"]:checked'); if (back) back.focus(); return; }
    m = t.name && t.name.match(/^gkk-size-(.+)$/);
    if (m) { if (S.sel[m[1]]) S.sel[m[1]].size = t.value; renderRole(m[1]); renderProgress(); clearFlash('beads'); renderFlow(); var again = $('input[name="' + t.name + '"]:checked'); if (again) again.focus(); roleDone(m[1]); return; }
    if (t.matches('[data-include]')) { var ri = t.getAttribute('data-include'); if (S.sel[ri]) S.sel[ri].include = t.checked; renderRole(ri); renderProgress(); clearFlash('beads'); renderFlow(); var inc = $('[data-include="' + ri + '"]'); if (inc) inc.focus(); return; }
    if (t.matches('[data-pref]')) { roleDone(t.getAttribute('data-pref'), false); return; }
    if (t.matches('[data-length]')) { S.length = Number(t.value) || null; clearFlash('base'); progress('base'); return; }
    if (t.name === 'gkk-chain') { S.chain = t.value === 'thread' ? 'thread' : 'beads'; clearFlash('base'); renderBases(); progress('base'); return; }
    if (t.name === 'gkk-base-size') { S.baseSize = Number(t.value); renderBases(); renderFlow(); return; }
    if (t.name === 'gkk-build') { S.build = t.value; if (S.build !== 'all-silver') S.silverDesign = null; renderBuildExtra(); clearFlash('build'); progress('build'); return; }
    if (t.name === 'gkk-colour') { S.colour = t.value; renderFlow(); return; }
    if (t.name === 'gkk-silver') { S.silverDesign = t.value; clearFlash('build'); progress('build'); return; }
    if (t.name === 'gkk-energy') { S.energy = t.value; renderFlow(); return; }
    if (t.matches('[data-design]')) {
      var f = t.files && t.files[0];
      if (!f) return;
      if (!(/^image\//.test(f.type) || f.type === 'application/pdf' || /\.pdf$/i.test(f.name))) { t.value = ''; flash('extras', 'Please upload an image or a PDF.'); return; }
      if (f.size > MAX_DESIGN) { t.value = ''; flash('extras', 'That file is over 10 MB. Please upload a smaller file or send it on WhatsApp.'); return; }
      S.design = f; $('[data-design-name]').textContent = f.name + ' attached.'; clearFlash('extras'); renderFlow();
    }
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-pref]')) { e.preventDefault(); roleDone(e.target.getAttribute('data-pref')); }
  });
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-pref]')) { var r = t.getAttribute('data-pref'); if (S.sel[r]) S.sel[r].pref = t.value.slice(0, 40); refreshRoleHead(r); renderProgress(); renderFlow(); return; }
    if (t.matches('[data-note]')) { S.note = t.value.slice(0, 300); }
  });
  root.addEventListener('click', function (e) {
    var t = e.target;
    var info = t.closest('[data-info-open]');
    if (info) { openInfo(info.getAttribute('data-info-open'), info); return; }
    var bs = t.closest('[data-base]');
    if (bs) {
      var k = bs.getAttribute('data-base'), i = S.bases.indexOf(k);
      if (i > -1) S.bases.splice(i, 1);
      else if (S.bases.length >= 2) { flash('base', 'You can mix up to 2 kinds of back chain beads. Remove one first.'); return; }
      else S.bases.push(k);
      clearFlash('base'); renderBases(); progress('base');
      var again = $('[data-base="' + k + '"]'); if (again) again.focus();
      return;
    }
    var bi = t.closest('[data-bead-info]'); if (bi) { showBeadInfo(bi.getAttribute('data-bead-info')); return; }
    if (t.closest('[data-preview-zoom]')) { openLabelledPreview(t.closest('[data-preview-zoom]')); return; }
    if (t.closest('[data-bar-cta]')) { var evb = evaluate(); if (firstMissing(evb)) goToMissing(evb); else { if (!OPENED.review) { OPENED.review = true; renderFlow(); } scrollToStep('review'); } return; }
    if (t.closest('[data-buy]')) { buy(); return; }
    if (t.closest('[data-quote]')) { var ev = evaluate(); if (ev.todo.length) { message(ev.todo[0].msg, 'error'); goToMissing(ev); return; } window.open('https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(designText(ev)), '_blank', 'noopener'); return; }
    if (t.closest('[data-copy]')) {
      var evc = evaluate(); if (evc.todo.length) { message(firstMissing(evc).msg, 'error'); goToMissing(evc); return; } var txt = designText(evc);
      var done = function () { message('Design details copied. You can paste them into WhatsApp or email.', 'ok'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, function () { message('Copy is blocked on this device. Please use the WhatsApp button.', 'error'); });
      else message('Copy is not supported on this device. Please use the WhatsApp button.', 'error');
    }
  });
  var dlg = $('[data-dialog]');
  dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-close]')) dlg.close(); });
  dlg.addEventListener('close', function () { if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus(); lastTrigger = null; });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; setBusy(false); } });

  /* ---------- start ---------- */
  $('#gkk-note').value = '';
  $('[data-length]').value = '';
  renderMalas();
  renderOrigins();
  renderEnergy();
  renderFlow();
  syncStickyTop();
  var stickyRaf = 0;
  window.addEventListener('scroll', function () { if (!stickyRaf) stickyRaf = requestAnimationFrame(function () { stickyRaf = 0; syncStickyTop(); }); }, { passive: true });
  window.addEventListener('resize', syncStickyTop);
  var previewWide = null;
  window.addEventListener('resize', function () { if (!OPENED.review) return; var host = $('[data-preview]'); var wide = (host.parentNode.clientWidth || 0) >= 600; if (wide !== previewWide) { previewWide = wide; renderPreview(evaluate()); } });
})();
